export async function downloadOPFS(filename: string) {
    const root = await navigator.storage.getDirectory();
    try {
        if (window.showSaveFilePicker) {
            const result = await window.showSaveFilePicker({
                suggestedName: filename,
                types: [{ accept: { 'text/plain': '.txt' } }]
            });
            const fileHandle = await root.getFileHandle(filename, { create: false });
            const fileOut = await result.createWritable();
            const sourceFile = await fileHandle.getFile();
            sourceFile.stream().pipeTo(fileOut);
        } else {
            const fileHandle = await root.getFileHandle(filename, { create: false });
            const file = await fileHandle.getFile();
            const blobUrl = URL.createObjectURL(file);

            const a = document.createElement('a');
            a.href = blobUrl;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(blobUrl);
        }
    } catch (error) {
        console.error('Error downloading file:', error);
    }
}

export async function downloadOrSaveJson(filename: string, content: string) {
    try {
        if (window.showSaveFilePicker) {
            const result = await window.showSaveFilePicker({
                suggestedName: filename,
                types: [
                    {
                        accept: {
                            'application/json': '.json'
                        }
                    }
                ]
            });
            const fileOut = await result.createWritable({ keepExistingData: false });
            await fileOut.write(content);
            await fileOut.close();
        } else {
            const blobUrl = URL.createObjectURL(new Blob([content], { type: 'application/json' }));
            const a = document.createElement('a');
            a.href = blobUrl;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(blobUrl);
        }
    } catch (error) {
        console.error('Error downloading file:', error);
    }
}
